import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockRealInventoryModel } from "../realInventoryStatisticModel";
import { IStockRealInventoryDetail } from "../realInventoryStatisticService"
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
        setHistoryVisible,
        setHistoryRow,
        setOccupyStockModel,
        relocationList, setRelocationList,
        setRecordsSearch,
        setRecordsVisible,
        realInventorys
    } = useStockRealInventoryModel();
    const onHistoryModel = (record: IStockRealInventoryDetail) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }

    useEffect(() => {
        loadData().then();
    }, [])

    const defaultColumns: ColumnsType<IStockRealInventoryDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '移库记录',
            width: 80,
            dataIndex: 'num',
            render: (text: string, record: any) => <span onClick={() => {
                if (record.num === 0) {
                    return false
                } else {
                    setRecordsSearch({ stockId: record.id })
                    setRecordsVisible(true)
                }

            }} className="click-span">{text}</span>
        }, {
            title: '商品类型',
            width: 100,
            dataIndex: 'typeName',
        }, {
            title: '替换编号',
            width: 120,
            dataIndex: 'replaceCode',
        }, {
            title: '仓库',
            width: 130,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 100,
            dataIndex: 'shelfCode',
        }, {
            title: '初始库存',
            width: 80,
            dataIndex: 'inventoryInitial',
        }, {
            title: '库存数量',
            width: 80,
            dataIndex: 'inventoryNum',
        },
        // {
        //     title: '占用库存',
        //     width: 80,
        //     dataIndex: 'inventoryOccupied',
        //     render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title="占用库存查看"><p className="ellipsis click-span" onClick={(e) => {
        //         e.stopPropagation();
        //         setOccupyStockModel(record);
        //         return;

        //     }}>{text}</p></Tooltip>,
        // }, 
        {
            title: '可用库存',
            width: 80,
            dataIndex: 'availableStock',
        }, {
            title: '档案进价',
            width: 130,
            dataIndex: 'purchasePrice',
            render: (text) => text ? '￥' + text : '￥0'
        }, {
            title: '档案销价',
            width: 130,
            dataIndex: 'retailPrice',
            render: (text) => text ? '￥' + text : '￥0'
        },
        //  {
        //     title: '进货价(最近进价)',
        //     width: 130,
        //     dataIndex: 'latestPurPrice',
        //     render: (text) => text ? '￥' + text : '￥0'
        // }, {
        //     title: '进货价(平均价)',
        //     width: 130,
        //     dataIndex: 'averagePurchasePrice',
        //     render: (text) => text ? '￥' + text : '￥0'
        // }, {
        //     title: '库存成本(最近进价)',
        //     width: 160,
        //     dataIndex: 'latestAmount',
        //     render: (text) => text ? '￥' + text : '￥0'
        // }, {
        //     title: '库存成本(平均价)',
        //     width: 130,
        //     dataIndex: 'averageAmount',
        //     render: (text) => text ? '￥' + text : '￥0'
        // }, {
        //     title: '零售价(最近)',
        //     width: 120,
        //     dataIndex: 'lateSalePrice',
        //     render: (text) => text ? '￥' + text : '￥0'
        // }, 
        // {
        //     title: '库存上限',
        //     width: 80,
        //     dataIndex: 'limitUpper',
        // }, 
        {
            title: '库存下限',
            width: 80,
            dataIndex: 'limitLower',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
        // }, {
        //     title: '新仓库',
        //     width: 120,
        //     fixed: "right",
        //     dataIndex: 'warehouseNameNew',
        //     render: () => '新仓库'
        // }, {
        //     title: '新货位',
        //     width: 120,
        //     fixed: "right",
        //     dataIndex: 'warehouseNameNew',
        //     render: () => '新货位'
        // }, {
        //     title: '移库数量',
        //     width: 120,
        //     fixed: "right",
        //     dataIndex: 'relocationNum',
        //     render: () => '移库数量'
        // }, {
        //     title: '操作',
        //     width: 60,
        //     fixed: "right",
        //     align: "center",
        //     render: (text: string, record: any) => <span className="click-span" onClick={(e) => {
        //         e.stopPropagation()
        //         setSelectedRowKeys([record.id as string]);
        //         setRelocationList([record])
        //         setRelocationVisible(true)
        //     }}>移库</span>
        // }
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockStatic", "roleCodes": roles };
        return getRoleColumns("stockStatic", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (record: IStockRealInventoryDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = relocationList.findIndex((item) => (item.id === id))
        let newRelocationList = [...relocationList];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newRelocationList.push(record)
            setRelocationList(newRelocationList)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newRelocationList.splice(findIndexDesc, 1);
            setRelocationList(newRelocationList);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    return (
        <>
            <Table
                bordered
                size={tableSize}
                loading={loading}
                style={{ cursor: "pointer" }}
                rowKey={record => record.id as string}
                rowSelection={{
                    type: "checkbox",
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IStockRealInventoryDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys);
                        setRelocationList(selectedRows)
                    },
                    selectedRowKeys
                }}
                columns={roleColumns}
                dataSource={dataSource}
                pagination={{
                    showSizeChanger: true,
                    ...pgCfg,
                    defaultPageSize: 25,
                    pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                    position: ["bottomRight"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                onRow={record => {
                    return {
                        onClick: () => onRow(record),
                        onContextMenu: (e) => {
                            e.preventDefault();
                            setSelectedRowKeys([record.id as string]);
                            setRelocationList([record])
                        }
                    };
                }}
                scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}
                summary={() => (
                    <Table.Summary fixed>
                        <Table.Summary.Row className="table-total-box">
                            <Table.Summary.Cell index={0}>
                                <div className="title">合计</div>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} />
                            <Table.Summary.Cell index={2} />
                            <Table.Summary.Cell index={3} />
                            <Table.Summary.Cell index={4} />
                            <Table.Summary.Cell index={5} />
                            <Table.Summary.Cell index={6} />
                            <Table.Summary.Cell index={7} />
                            <Table.Summary.Cell index={8} />
                            <Table.Summary.Cell index={9} />
                            <Table.Summary.Cell index={10} />
                            <Table.Summary.Cell index={11}>
                                <span className="red">{realInventorys?.stockNum ?? 0}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={12} />
                            <Table.Summary.Cell index={13} />
                            <Table.Summary.Cell index={14} />
                            <Table.Summary.Cell index={15} />
                            <Table.Summary.Cell index={16} />
                            {/* <Table.Summary.Cell index={17} >
                                <span className="red">{realInventorys?.stockAmount ?? 0}</span>
                            </Table.Summary.Cell> */}
                            <Table.Summary.Cell index={17} />
                            {/* <Table.Summary.Cell index={18} />
                            <Table.Summary.Cell index={19} />
                            <Table.Summary.Cell index={20} />
                            <Table.Summary.Cell index={21} />
                            <Table.Summary.Cell index={22} />
                            <Table.Summary.Cell index={23} /> */}
                        </Table.Summary.Row>
                    </Table.Summary>
                )}
            />
        </>
    )
}
